import { css } from 'astroturf';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import ReactTooltip from 'react-tooltip';
import { CollectionCard, SnippetCard } from './components/_catalogCard';
import CollectionPanel from './components/_collectionPanel';
import Link from '../../components/link';
import { readSearchParam, subscribeToDialogSearchParamsChange } from './components/_dialogSearchParams';

const styles = css`
  .wrapper h1 {
    font-size: 1rem;
    font-weight: 600;
    text-align: center;
    margin: 0 auto;
    max-width: 1585px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    margin-top: 0rem;
    padding: 0.5rem 1rem;
    line-height: 1.25em;
    color: #007e9b;

    svg {
      width: 1.25em;
      height: 1.25em;
    }

    @media (min-width: 40rem) {
      flex-direction: row;
    }

    span {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }

    em {
      margin-left: 1.5rem;
      font-size: 0.875em;
      font-style: normal;
      font-weight: normal;
      color: #008600;

      @media (min-width: 40rem) {
        margin-left: 0;
      }
    }
  }

  .sidebarSearch {
    margin-bottom: 1rem;
    margin-left: -0.5rem;

    input {
      outline: none;
      background: #fff;
      display: block;
      font-size: 1rem;
      padding: 0.75rem 0.5rem;
      width: 100%;
      border-radius: 4px;
      border: 1px solid #d9dde7;
    }
  }

  .panel {
    border-right: 1px solid #d9dde7;
    padding-right: 1rem;
  }

  .layout {
    width: 100%;
    max-width: 100%;
    min-height: calc(100svh - 170px);
    margin: 0;
    border-top: 1px solid #d9dde7;
    display: grid;
    grid-template-columns: 320px minmax(0, 1fr) 0;
    gap: 0;
    align-items: stretch;
    position: relative;

    &.collectionOpen {
      grid-template-columns: 320px minmax(0, 1fr) 340px;
    }
  }

  .leftCol {
    position: relative;
    background: #fff;
    padding: 0 1.5rem;
    border-right: 1px solid #d9dde7;
    box-shadow:
      0 0 0 1px rgba(0, 0, 0, 0.024),
      0 1px 0 rgba(0, 0, 0, 0.05),
      0 0 8px rgba(0, 0, 0, 0.03),
      0 20px 30px rgba(0, 0, 0, 0.1);
  }

  .sidebarPanel {
    padding: 0;
  }

  .centerCol {
    padding: 1.5rem 1.5rem 0;
  }

  .sectionBlock {
    background: none;
    border: 0;
    border-radius: 0;
    padding: 0 0 4rem;
  }

  .sectionHeader {
    display: flex;
    align-items: center;

    gap: 0.75rem;
    margin-bottom: 0.75rem;
    border-bottom: 0;

    svg {
      color: #39728d;
    }
  }

  .sectionTitle {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
    line-height: 35px;
    color: #0f172a;
  }

  .sectionMeta {
    font-size: 0.9rem;
    color: #5c6779;
    line-height: 1;
  }

  .rightCol {
    position: relative;
    min-width: 0;
    background: #fff;
    padding: 0;
    border-left: 0;
    height: 100%;
    opacity: 0;
    pointer-events: none;
    overflow: visible;
    box-shadow:
      0 0 0 1px rgba(0, 0, 0, 0.024),
      0 1px 0 rgba(0, 0, 0, 0.05),
      0 0 8px rgba(0, 0, 0, 0.03),
      0 20px 30px rgba(0, 0, 0, 0.1);
  }

  .layout.collectionOpen .rightCol {
    padding: 0 1.5rem;
    border-left: 1px solid #d9dde7;
    opacity: 1;
    pointer-events: auto;
  }

  .filterPanel {
    height: auto;
    padding: 1.5rem 0;
    position: sticky;
    top: 75px;

    .heading {
      margin: 0 0 0.75rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0.5rem;
    }

    .headingActions {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
    }

    p {
      background: #00aeff11;
      font-size: 0.75rem;
      padding: 0.75rem 1.5rem;
      margin-left: -1.5rem;
      margin-right: -1.5rem;
      margin-bottom: 1rem;
      display: flex;
      align-items: start;
      gap: 0.5rem;
      justify-content: start;

      &.vcenter {
        align-items: center;
      }

      @media (max-width: 60rem) {
        display: none;
      }

      & svg {
        color: #39728d;
        width: 1.5rem;
        height: 1.5rem;
        flex-basis: 1.5rem;
        flex-shrink: 0;
      }
    }

    h2 {
      margin: 0;
      font-size: 1.25rem;
      font-weight: 600;
      line-height: 35px;
      color: #0f172a;
    }

    .heading svg {
      color: #39728d;
    }

    .clear {
      border: 0;
      background: none;
      color: #39728d;
      font-weight: 700;
      font-size: 12px;
      padding: 0;
      width: auto;
      opacity: 0;
      visibility: hidden;
      pointer-events: none;
      transition: 0.15s ease-in-out opacity;

      &:hover,
      &:focus-visible {
        background: none;
        color: #0a1530;
      }
    }

    .clearVisible {
      opacity: 1;
      visibility: visible;
      pointer-events: auto;
    }

    .panelClose {
      display: none;
      border: 0;
      background: none;
      color: #39728d;
      font-weight: 700;
      font-size: 12px;
      padding: 0;
      width: auto;

      &:hover,
      &:focus-visible {
        background: none;
        color: #0a1530;
      }
    }

    .groupHeader {
      margin: 0;
      display: flex;
      align-items: baseline;
      justify-content: space-between;
      gap: 0.5rem;
      font-size: 0.875rem;
      line-height: 1;
      padding-bottom: 0.125rem;
      font-weight: 600;
      color: #0a1530;
      width: 100%;
    }

    .groupClear {
      border: 0;
      background: none;
      color: #39728d;
      font-weight: 700;
      font-size: 12px;
      padding: 0;
      width: auto;
      opacity: 0;
      visibility: hidden;
      pointer-events: none;
      transition: 0.15s ease-in-out opacity;

      &:hover,
      &:focus-visible {
        background: none;
        color: #0a1530;
      }
    }

    .groupClearVisible {
      opacity: 1;
      visibility: visible;
      pointer-events: auto;
    }

    .filterGroup {
      border: 0;
      padding: 0;
      padding-top: 0.3rem;
      margin: 0;
      margin-top: 0.3rem;

      &:first-of-type {
        padding-top: 0;
        margin-top: 0;
      }
    }

    .checkboxList {
      display: flex;
      flex-direction: column;
      gap: 0.2rem;
      margin-bottom: 0.4rem;
      max-height: 210px;
      overflow: auto;
    }

    .inlineCheckboxes {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 0.35rem 0.75rem;
    }

    label {
      display: flex;
      align-items: center;
      gap: 0.45rem;
      font-size: 0.875rem;
      color: #333;

      small {
        color: #39728d;
      }

      input {
        margin: 0;
        accent-color: rgb(16, 125, 181);
        padding: 2px;
        width: 0.875rem;
        height: 0.875rem;
        font-size: 1rem;
      }
    }

    button {
      border: 0;
      background: #0a1530;
      color: #fff;
      padding: 0.55rem 0.8rem;
      border-radius: 4px;
      width: 100%;
      font-weight: 600;

      &:hover,
      &:focus-visible {
        background: rgb(20, 31, 64);
      }
    }
  }

  .resultsGrid {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    gap: 1rem;
  }

  .collectionsSection {
    min-height: 260px;
  }

  .empty {
    padding: 0.2rem 0.4rem;
    background: none;
    border-radius: 0;
    color: #666;
  }

  .sidebarCollection {
    margin-top: 0;
    border: 0;
    border-radius: 0;
    box-shadow: none;
    padding-top: 1.5rem;
    position: sticky;
    top: 75px;
    @media (max-width: 40rem) {
      padding-top: 0;
    }
  }

  .filterToggle {
    display: none;
  }

  .filterToggleHidden {
    display: none;
  }

  @media (max-width: 60rem) {
    .layout {
      grid-template-columns: minmax(0, 1fr) 0;
    }

    .layout.collectionOpen {
      grid-template-columns: minmax(0, 1fr) 340px;
    }

    .leftCol {
      position: absolute;
      inset: 0 auto 0 0;
      width: min(320px, 100%);
      z-index: 20;
      transform: translateX(-100%);
      pointer-events: none;
      padding: 0 1rem;
      overflow-y: auto;
      overflow-x: visible;
      @media (prefer-reduced-motion: no-preference) {
        transition: transform 0.15s ease-in-out;
      }
    }

    .layout.filtersOpen .leftCol {
      transform: translateX(0);
      pointer-events: auto;
    }

    .centerCol {
      padding: 1rem;
    }

    .filterPanel {
      position: static;
      top: auto;
      max-height: none;
      overflow: visible;
      padding: 1rem 0 1.5rem;

      .panelClose {
        display: inline-flex;
        align-items: center;
      }
    }

    .filterToggle {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border: 0;
      border-radius: 4px;
      padding: 0.55rem 0.8rem;
      margin-bottom: 1rem;
      background: #0a1530;
      color: #fff;
      font-weight: 600;

      &:hover,
      &:focus-visible {
        background: rgb(20, 31, 64);
      }
    }
  }

  @media (max-width: 40rem) {
    .layout,
    .layout.collectionOpen {
      grid-template-columns: minmax(0, 1fr) 0;
    }

    .rightCol {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: auto;
      max-height: 70svh;
      overflow: auto;
      z-index: 25;
      transform: translateY(100%);
      border-left: 0;
      border-top: 1px solid #d9dde7;
      box-shadow:
        0 -12px 24px rgba(0, 0, 0, 0.12),
        0 0 0 1px rgba(0, 0, 0, 0.024);
      padding: 0 1rem;
      @media (prefer-reduced-motion: no-preference) {
        transition: transform 0.15s ease-in-out;
      }
    }

    .layout.collectionOpen .rightCol {
      transform: translateY(0);
      padding: 0 1rem;
      border-left: 0;
      border-top: 1px solid #d9dde7;
      opacity: 1;
      pointer-events: auto;
    }
  }
`;

function normalizeType(language) {
  return language === 'javascript' ? 'js' : 'css';
}

function downloadBlob(filename, payload) {
  const blob = new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json' });
  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(blobUrl);
}

function getSharedCategories(snippets) {
  if (!snippets.length) {
    return [];
  }

  const baseline = snippets[0].categories || [];
  if (!baseline.length) {
    return [];
  }

  const baselineKey = baseline.slice().sort().join('::');
  const allMatch = snippets.every((snippet) => {
    const categories = (snippet.categories || []).slice().sort().join('::');
    return categories === baselineKey;
  });

  return allMatch ? baseline : [];
}

function buildCollectionFolder(collectionName, snippets, description, author) {
  const folder = {
    name: collectionName,
    children: snippets.map((snippet) => snippet.download),
  };

  const sharedAuthor = snippets.length
    ? snippets.every((snippet) => snippet.author === snippets[0].author)
      ? snippets[0].author
      : ''
    : '';

  const sharedCategories = getSharedCategories(snippets);

  if (author) {
    folder.author = author;
  } else if (sharedAuthor) {
    folder.author = sharedAuthor;
  }

  if (sharedCategories.length) {
    folder.categories = sharedCategories;
  }

  if (description) {
    folder.description = description;
  }

  return [folder];
}

function slugify(input) {
  return input
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-_]/g, '');
}

function toggleSelected(setter, value) {
  setter((current) => (current.includes(value) ? current.filter((entry) => entry !== value) : [...current, value]));
}

const FilterGroup = React.memo(
  ({ title, items, textItems, counts, selected, onToggle, onClearGroup, inline = false }) => {
    const canClearGroup = Boolean(onClearGroup && selected.length);

    return (
      <fieldset className={styles.filterGroup}>
        <legend className={styles.groupHeader}>
          {title}
          {onClearGroup && (
            <button
              className={[styles.groupClear, canClearGroup ? styles.groupClearVisible : ''].join(' ')}
              type="button"
              onClick={onClearGroup}
              tabIndex={canClearGroup ? 0 : -1}
              aria-hidden={!canClearGroup}
            >
              Clear
            </button>
          )}
        </legend>
        <div className={[styles.checkboxList, inline ? styles.inlineCheckboxes : ''].join(' ')}>
          {items.map((value, index) => (
            <label key={value}>
              <input type="checkbox" checked={selected.includes(value)} onChange={() => onToggle(value)} />
              <span>
                {textItems ? textItems[index] : value}
                {counts ? <small> ({counts[value] ?? 0})</small> : null}
              </span>
            </label>
          ))}
        </div>
      </fieldset>
    );
  }
);

const prevent = (event) => {
  event.preventDefault();
  return false;
};

const FilterPanel = React.memo(
  ({
    query,
    onQueryChange,
    authors,
    authorCounts,
    categories,
    categoryCounts,
    selectedAuthors,
    selectedCategories,
    selectedTypes,
    selectedContent,
    hasActiveFilters,
    onToggle,
    onClear,
    onClosePanel,
  }) => {
    const canClearAll = Boolean(hasActiveFilters);

    return (
      <form className={styles.filterPanel} onSubmit={prevent}>
        <div className={styles.heading}>
          <h2>Filter</h2>
          <div className={styles.headingActions}>
            <button
              className={[styles.clear, canClearAll ? styles.clearVisible : ''].join(' ')}
              type="button"
              onClick={onClear}
              tabIndex={canClearAll ? 0 : -1}
              aria-hidden={!canClearAll}
            >
              Clear all
            </button>
            <button className={styles.panelClose} type="button" onClick={onClosePanel}>
              Close
            </button>
          </div>
        </div>
        <div className={styles.sidebarSearch}>
          <input
            type="search"
            value={query}
            onChange={(event) => onQueryChange(event.target.value)}
            placeholder="Search snippets and collections"
            aria-label="Search snippets and collections"
          />
        </div>
        <p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="icon icon-tabler icons-tabler-outline icon-tabler-badge"
          >
            <path d="M17 17v-13l-5 3l-5 -3v13l5 3l5 -3" />
          </svg>
          <span>
            <Link to="/docs/snippets/">Learn more about snippets</Link>.
          </span>
        </p>

        <FilterGroup
          title="Show"
          items={['snippets', 'collections']}
          textItems={['Snippets', 'Collections']}
          selected={selectedContent}
          inline
          onToggle={(v) => onToggle('content', v)}
        />
        <FilterGroup
          title="Type"
          items={['css', 'js']}
          selected={selectedTypes}
          textItems={['CSS', 'JavaScript']}
          inline
          onToggle={(v) => onToggle('type', v)}
        />
        <FilterGroup
          title="Category"
          items={categories}
          counts={categoryCounts}
          selected={selectedCategories}
          onToggle={(v) => onToggle('category', v)}
          onClearGroup={() => selectedCategories.forEach((value) => onToggle('category', value))}
        />
        <FilterGroup
          title="Author"
          items={authors}
          counts={authorCounts}
          selected={selectedAuthors}
          onToggle={(v) => onToggle('author', v)}
          onClearGroup={() => selectedAuthors.forEach((value) => onToggle('author', value))}
        />

        <p className={styles.vcenter}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="icon icon-tabler icons-tabler-outline icon-tabler-brand-github"
          >
            <path d="M9 19c-4.3 1.4 -4.3 -2.5 -6 -3m12 5v-3.5c0 -1 .1 -1.4 -.5 -2c2.8 -.3 5.5 -1.4 5.5 -6a4.6 4.6 0 0 0 -1.3 -3.2a4.2 4.2 0 0 0 -.1 -3.2s-1.1 -.3 -3.5 1.3a12.3 12.3 0 0 0 -6.2 0c-2.4 -1.6 -3.5 -1.3 -3.5 -1.3a4.2 4.2 0 0 0 -.1 3.2a4.6 4.6 0 0 0 -1.3 3.2c0 4.6 2.7 5.7 5.5 6c-.6 .6 -.6 1.2 -.5 2v3.5" />
          </svg>
          <span>
            Submit snippets via our <Link to="https://github.com/Polypane/snippets">GitHub repo</Link>.
          </span>
        </p>
      </form>
    );
  }
);

export default function SnippetCatalog({ snippets }) {
  const [query, setQuery] = useState('');
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);
  const [selectedAuthors, setSelectedAuthors] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState(['css', 'js']);
  const [selectedContent, setSelectedContent] = useState(['snippets', 'collections']);
  const [collectionTitle, setCollectionTitle] = useState('');
  const [collectionAuthor, setCollectionAuthor] = useState('');
  const [collectionDescription, setCollectionDescription] = useState('');
  const [collectionItems, setCollectionItems] = useState([]);

  const [activeSnippet, setActiveSnippet] = useState(() =>
    typeof window !== 'undefined' ? readSearchParam('snippet') : null
  );
  const [activeCollection, setActiveCollection] = useState(() =>
    typeof window !== 'undefined' ? readSearchParam('collection') : null
  );

  useEffect(() => {
    const sync = () => {
      setActiveSnippet(readSearchParam('snippet'));
      setActiveCollection(readSearchParam('collection'));
    };

    return subscribeToDialogSearchParamsChange(sync);
  }, []);

  useEffect(() => {
    ReactTooltip.rebuild();
  }, [query, selectedAuthors, selectedCategories, selectedTypes, selectedContent]);

  const authors = useMemo(
    () =>
      Array.from(new Set(snippets.map((snippet) => snippet.author).filter((a) => Boolean(a) && a !== 'Unknown'))).sort(
        (a, b) => a.localeCompare(b)
      ),
    [snippets]
  );

  const categories = useMemo(
    () =>
      Array.from(
        new Set(
          snippets.reduce((allCategories, snippet) => {
            (snippet.categories || []).forEach((category) => allCategories.push(category));
            return allCategories;
          }, [])
        )
      ).sort((a, b) => a.localeCompare(b)),
    [snippets]
  );

  const categoryCounts = useMemo(() => {
    const counts = {};

    snippets.forEach((snippet) => {
      (snippet.categories || []).forEach((category) => {
        counts[category] = (counts[category] || 0) + 1;
      });
    });

    return counts;
  }, [snippets]);

  const authorCounts = useMemo(() => {
    const counts = {};

    snippets.forEach((snippet) => {
      if (snippet.author && snippet.author !== 'Unknown') {
        counts[snippet.author] = (counts[snippet.author] || 0) + 1;
      }
    });

    return counts;
  }, [snippets]);

  const sourceCollections = useMemo(() => {
    const grouped = snippets.reduce((acc, snippet) => {
      if (!snippet.folderName) {
        return acc;
      }

      if (!acc[snippet.folderName]) {
        acc[snippet.folderName] = [];
      }

      acc[snippet.folderName].push(snippet);
      return acc;
    }, {});

    return Object.keys(grouped)
      .sort((a, b) => a.localeCompare(b))
      .map((folderName) => {
        const folderSnippets = grouped[folderName].slice().sort((a, b) => a.name.localeCompare(b.name));
        const uniqueAuthors = Array.from(new Set(folderSnippets.map((snippet) => snippet.author).filter(Boolean)));
        const singleAuthor = uniqueAuthors.length === 1;
        const authorUrl = singleAuthor
          ? folderSnippets.find((s) => s.author === uniqueAuthors[0])?.authorUrl || null
          : null;
        const uniqueCategories = Array.from(
          new Set(
            folderSnippets.reduce((all, snippet) => {
              (snippet.categories || []).forEach((cat) => all.push(cat));
              return all;
            }, [])
          )
        ).sort((a, b) => a.localeCompare(b));
        const uniqueTypes = Array.from(
          new Set(folderSnippets.map((snippet) => normalizeType(snippet.language)))
        ).sort();

        return {
          name: folderName,
          snippets: folderSnippets,
          author: singleAuthor ? uniqueAuthors[0] : 'Multiple authors',
          authorUrl,
          categories: uniqueCategories,
          types: uniqueTypes,
          description: folderSnippets[0].folderDescription || '',
        };
      });
  }, [snippets]);

  const filteredCollections = useMemo(() => {
    const normalizedQuery = query.trim().toLowerCase();

    return sourceCollections.filter((collection) => {
      if (selectedAuthors.length && !collection.snippets.some((snippet) => selectedAuthors.includes(snippet.author))) {
        return false;
      }

      if (selectedCategories.length && !selectedCategories.some((cat) => collection.categories.includes(cat))) {
        return false;
      }

      if (selectedTypes.length && !selectedTypes.some((type) => collection.types.includes(type))) {
        return false;
      }

      if (!normalizedQuery) {
        return true;
      }

      const searchable = [
        collection.name,
        collection.description,
        collection.author,
        collection.categories.join(' '),
        collection.snippets.map((snippet) => snippet.name).join(' '),
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();

      return searchable.includes(normalizedQuery);
    });
  }, [query, selectedAuthors, selectedCategories, selectedTypes, sourceCollections]);

  const filteredSnippets = useMemo(() => {
    const normalizedQuery = query.trim().toLowerCase();

    return snippets
      .filter((snippet) => {
        if (selectedAuthors.length && !selectedAuthors.includes(snippet.author)) {
          return false;
        }

        if (selectedCategories.length && !selectedCategories.some((cat) => (snippet.categories || []).includes(cat))) {
          return false;
        }

        if (selectedTypes.length && !selectedTypes.includes(normalizeType(snippet.language))) {
          return false;
        }

        if (!normalizedQuery) {
          return true;
        }

        const searchableText = [
          snippet.name,
          snippet.description,
          snippet.author,
          (snippet.categories || []).join(' '),
          snippet.folderName,
          normalizeType(snippet.language),
        ]
          .filter(Boolean)
          .join(' ')
          .toLowerCase();

        return searchableText.includes(normalizedQuery);
      })
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [query, selectedAuthors, selectedCategories, selectedTypes, snippets]);

  const collectionMap = useMemo(
    () =>
      collectionItems.reduce((acc, snippet) => {
        acc[snippet.id] = true;
        return acc;
      }, {}),
    [collectionItems]
  );

  const handleToggleFilter = useCallback((kind, value) => {
    if (kind === 'author') {
      toggleSelected(setSelectedAuthors, value);
      return;
    }

    if (kind === 'category') {
      toggleSelected(setSelectedCategories, value);
      return;
    }

    if (kind === 'type') {
      toggleSelected(setSelectedTypes, value);
      return;
    }

    toggleSelected(setSelectedContent, value);
  }, []);

  const clearFilters = useCallback(() => {
    setSelectedAuthors([]);
    setSelectedCategories([]);
    setSelectedTypes(['css', 'js']);
    setSelectedContent(['snippets', 'collections']);
    setQuery('');
  }, []);

  const addToCollection = useCallback((snippet) => {
    setCollectionItems((current) => {
      if (current.some((entry) => entry.id === snippet.id)) {
        return current.filter((entry) => entry.id !== snippet.id);
      }

      return [...current, snippet];
    });
  }, []);

  const removeFromCollection = useCallback((snippetId) => {
    setCollectionItems((current) => current.filter((snippet) => snippet.id !== snippetId));
  }, []);

  const downloadSingle = useCallback((snippet) => {
    downloadBlob(`${slugify(snippet.name) || 'snippet'}.json`, snippet.download);
    if (typeof window !== 'undefined' && window.umami) {
      window.umami.track('Download snippet', { name: snippet.name });
    }
  }, []);

  const downloadCollection = useCallback(() => {
    const name = collectionTitle.trim() || 'Snippet Collection';
    const description = collectionDescription.trim() || `${collectionItems.length} snippets`;
    const payload = buildCollectionFolder(name, collectionItems, description, collectionAuthor.trim());
    downloadBlob(`${slugify(name) || 'snippet-collection'}.json`, payload);

    if (typeof window !== 'undefined' && window.umami) {
      window.umami.track('Download custom collection', { name, items: collectionItems.length });
    }
  }, [collectionTitle, collectionDescription, collectionItems, collectionAuthor]);

  const downloadListedCollection = useCallback((collection) => {
    const folder = {
      name: collection.name,
      children: collection.snippets.map((snippet) => snippet.download || snippet),
    };

    if (collection.author && collection.author !== 'Multiple authors') {
      folder.author = collection.author;
    }

    if (collection.categories && collection.categories.length) {
      folder.categories = collection.categories;
    }

    if (collection.description) {
      folder.description = collection.description;
    }

    const payload = [folder];
    downloadBlob(`${slugify(collection.name) || 'collection'}.json`, payload);
    if (typeof window !== 'undefined' && window.umami) {
      window.umami.track('Download collection', { name: collection.name, items: collection.snippets.length });
    }
  }, []);

  const addListedCollection = useCallback((collection) => {
    setCollectionItems(collection.snippets);
    setCollectionTitle(collection.name || '');
    setCollectionAuthor(collection.author && collection.author !== 'Multiple authors' ? collection.author : '');
    setCollectionDescription(collection.description || '');
  }, []);

  const clearCollectionBuilder = useCallback(() => {
    setCollectionItems([]);
    setCollectionTitle('');
    setCollectionAuthor('');
    setCollectionDescription('');
  }, []);

  const openFiltersPanel = useCallback(() => setIsFiltersOpen(true), []);
  const closeFiltersPanel = useCallback(() => setIsFiltersOpen(false), []);

  const showCollections = selectedContent.includes('collections');
  const showSnippets = selectedContent.includes('snippets');
  const hasDefaultTypeSelection =
    selectedTypes.length === 2 && ['css', 'js'].every((type) => selectedTypes.includes(type));
  const hasActiveFilters =
    query.trim().length > 0 ||
    selectedAuthors.length > 0 ||
    selectedCategories.length > 0 ||
    !hasDefaultTypeSelection ||
    selectedContent.length !== 2;

  return (
    <div className={styles.wrapper}>
      <h1>
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="icon icon-tabler icons-tabler-outline icon-tabler-badge"
          >
            <path d="M17 17v-13l-5 3l-5 -3v13l5 3l5 -3" />
          </svg>
          Snippet Store
        </span>
        <em>Find CSS and JS snippets and create your own collection to use in Polypane.</em>
      </h1>
      <div
        className={[
          styles.layout,
          collectionItems.length ? styles.collectionOpen : '',
          isFiltersOpen ? styles.filtersOpen : '',
        ].join(' ')}
      >
        <section className={styles.leftCol}>
          <FilterPanel
            query={query}
            onQueryChange={setQuery}
            authors={authors}
            authorCounts={authorCounts}
            categories={categories}
            categoryCounts={categoryCounts}
            selectedAuthors={selectedAuthors}
            selectedCategories={selectedCategories}
            selectedTypes={selectedTypes}
            selectedContent={selectedContent}
            hasActiveFilters={hasActiveFilters}
            onToggle={handleToggleFilter}
            onClear={clearFilters}
            onClosePanel={closeFiltersPanel}
          />
        </section>

        <section className={styles.centerCol}>
          <button
            className={[styles.filterToggle, isFiltersOpen ? styles.filterToggleHidden : ''].join(' ')}
            type="button"
            onClick={openFiltersPanel}
            aria-expanded={isFiltersOpen}
            aria-label="Open filters"
          >
            Filters
          </button>

          {showCollections && filteredCollections.length ? (
            <section className={[styles.sectionBlock, styles.collectionsSection].join(' ')}>
              <div className={styles.sectionHeader}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-folder-open"
                >
                  <path d="M5 19l2.757 -7.351a1 1 0 0 1 .936 -.649h12.307a1 1 0 0 1 .986 1.164l-.996 5.211a2 2 0 0 1 -1.964 1.625h-14.026a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v2" />
                </svg>
                <h3 className={styles.sectionTitle}>Collections</h3>
                <span className={styles.sectionMeta}>{filteredCollections.length}</span>
              </div>
              {filteredCollections.length ? (
                <div className={styles.resultsGrid}>
                  {filteredCollections.map((collection) => (
                    <CollectionCard
                      key={collection.name}
                      collection={collection}
                      onDownload={downloadListedCollection}
                      onAddToCollection={addListedCollection}
                      normalizeType={normalizeType}
                      activeSnippet={activeSnippet}
                      activeCollection={activeCollection}
                    />
                  ))}
                </div>
              ) : (
                <div className={styles.empty}>No collections match your current search and filters.</div>
              )}
            </section>
          ) : null}

          {showSnippets ? (
            <section className={styles.sectionBlock}>
              <div className={styles.sectionHeader}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-badge"
                >
                  <path d="M17 17v-13l-5 3l-5 -3v13l5 3l5 -3" />
                </svg>
                <h3 className={styles.sectionTitle}>Snippets</h3>
                <span className={styles.sectionMeta}>{filteredSnippets.length}</span>
              </div>
              {filteredSnippets.length ? (
                <div className={styles.resultsGrid}>
                  {filteredSnippets.map((snippet) => (
                    <SnippetCard
                      key={snippet.id}
                      snippet={snippet}
                      isInCollection={Boolean(collectionMap[snippet.id])}
                      onAdd={addToCollection}
                      onDownload={downloadSingle}
                      normalizeType={normalizeType}
                      activeSnippet={activeSnippet}
                      activeCollection={activeCollection}
                    />
                  ))}
                </div>
              ) : (
                <div className={styles.empty}>No snippets match your current search and filters.</div>
              )}
            </section>
          ) : null}

          {!showCollections && !showSnippets ? (
            <div className={styles.empty}>Enable snippets or collections in filters to see results.</div>
          ) : null}
        </section>

        <aside className={styles.rightCol}>
          <CollectionPanel
            className={styles.sidebarCollection}
            title={collectionTitle}
            author={collectionAuthor}
            description={collectionDescription}
            onTitleChange={setCollectionTitle}
            onAuthorChange={setCollectionAuthor}
            onDescriptionChange={setCollectionDescription}
            snippets={collectionItems}
            onDownload={downloadCollection}
            onRemove={removeFromCollection}
            onClear={clearCollectionBuilder}
          />
        </aside>
      </div>
    </div>
  );
}
